import { render, staticRenderFns } from "./product-stickers.vue?vue&type=template&id=33632a0d"
import script from "./product-stickers.vue?vue&type=script&lang=js"
export * from "./product-stickers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports